var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Aggregate", {
    attrs: {
      title: "Project Reserves",
      ItemConstructor: _vm.CaseModel.ReserveProject,
      cardProps: { outlined: true, class: [] },
      "toolbar-dense": "",
      dense: "",
    },
    on: {
      change: function ($event) {
        return _vm.$emit("change")
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "item.name",
          fn: function (ref) {
            var item = ref.item
            return [
              _c("v-text-field", {
                on: {
                  change: function ($event) {
                    return _vm.updateWhereAssigned(item.id, item.name)
                  },
                },
                model: {
                  value: item.name,
                  callback: function ($$v) {
                    _vm.$set(item, "name", $$v)
                  },
                  expression: "item.name",
                },
              }),
            ]
          },
        },
        {
          key: "default",
          fn: function (ref) {
            var item = ref.item
            return [
              _c("v-text-field", {
                attrs: {
                  label: "Duration (hours)",
                  suffix: "hours",
                  type: "number",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.param.duration,
                  callback: function ($$v) {
                    _vm.$set(item.param, "duration", _vm._n($$v))
                  },
                  expression: "item.param.duration",
                },
              }),
              _c("v-switch", {
                attrs: {
                  label: "Set Reserved Capacity",
                  hint: "Set a reserved capacity instead of taking reserve price from Market",
                  "persistent-hint": "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.set_reserved_capacity,
                  callback: function ($$v) {
                    _vm.$set(item, "set_reserved_capacity", $$v)
                  },
                  expression: "item.set_reserved_capacity",
                },
              }),
              item.set_reserved_capacity
                ? _c("v-text-field", {
                    staticClass: "my-5",
                    attrs: {
                      label: "Reserved Capacity",
                      hint: "Remember to add the Reserve service to the generators and storages",
                      "persistent-hint": "",
                      suffix: "MW",
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: item.param.capacity,
                      callback: function ($$v) {
                        _vm.$set(item.param, "capacity", _vm._n($$v))
                      },
                      expression: "item.param.capacity",
                    },
                  })
                : _vm._e(),
            ]
          },
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.computedValue,
      callback: function ($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }